"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _makeStyles.default)(({
  spacing
}) => ({
  text: {
    fontSize: 16,
    marginBottom: spacing(1.5)
  },
  button: {
    margin: spacing(0, 1)
  }
}));
const DefaultSwal = ({
  swal,
  text,
  confirmButtonProps = {},
  cancelButtonProps = {},
  showCancel
}) => {
  const {
    clickConfirm,
    clickCancel
  } = swal;
  const {
    text: cancelButtonText,
    ...cancelProps
  } = cancelButtonProps;
  const {
    text: confirmButtonText,
    ...confirmProps
  } = confirmButtonProps;
  const classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [typeof text === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      className: classes.text,
      children: text
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.text,
      children: text
    }), showCancel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      className: classes.button,
      ...cancelProps,
      onClick: clickCancel,
      children: cancelButtonText || 'Cancel'
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      className: classes.button,
      variant: "contained",
      color: "primary",
      ...confirmProps,
      onClick: clickConfirm,
      children: confirmButtonText || 'Okay'
    })]
  });
};
var _default = exports.default = DefaultSwal;